// TO MAKE THE MAP APPEAR YOU MUST
// ADD YOUR ACCESS TOKEN FROM
// https://account.mapbox.com
mapboxgl.accessToken = 'pk.eyJ1IjoibWljaGFlbC1idXJ0b24iLCJhIjoiY2xleXB6Y3ZiMDBqNjQwbXdqaHgxaDZqbSJ9.DB5mxDKKmEKG7wdajRI-pg'
